import { useCallback, useMemo, useState } from 'react';
import { setAllFolds, togglePatientFold, type FoldMode, type InboxFolds } from './inboxFolds';

// Keyed by patientId, so a patient still on the page after a refetch keeps its fold.
// A new Rows choice starts afresh: every patient follows it until toggled again.
export function useExpandedPatients(mode: FoldMode) {
    const [toggledFolds, setToggledFolds] = useState<InboxFolds>(() => setAllFolds(mode));
    const folds = useMemo(
        () => (toggledFolds.mode === mode ? toggledFolds : setAllFolds(mode)),
        [toggledFolds, mode]
    );

    const toggleExpanded = useCallback(
        (patientId: string) => {
            setToggledFolds((current) =>
                togglePatientFold(current.mode === mode ? current : setAllFolds(mode), patientId)
            );
        },
        [mode]
    );

    return { folds, toggleExpanded };
}
